import { render, staticRenderFns } from "./fkDetail.vue?vue&type=template&id=22e5b884&"
import script from "./fkDetail.vue?vue&type=script&lang=js&"
export * from "./fkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports